import { Component, OnInit } from '@angular/core';
import { Lang } from 'src/app/Constants/app.model';
import { DataService } from 'src/app/data.service';
import {environment} from 'src/environments/environment';

declare var Genesys: any; // <-- allow use of global Genesys object

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  currentLang: Lang = 'en';
  currentRouteMap: any;
  url:any;
  constructor(private readonly dataService: DataService) {
    this.dataService.selectedLang.subscribe(lang => {
      this.currentLang = lang;
    });
    this.dataService.currentRouteMap.subscribe(routeMap => {
      this.currentRouteMap = routeMap;
    });
  }
  ngOnInit(): void {
    this.url = environment.url;
  }

  openMessenger() {
    try {
      Genesys('subscribe', 'Messenger.ready', () => {
        Genesys(
          'command',
          'Messenger.open',
          {},
          () => {
            console.log('Messenger opened');
          },
          (error: any) => {
            console.error("Couldn't open messenger.", error);
          }
        );
      });
    } catch (err) {
      console.error('Genesys Messenger is not initialized yet.', err);
    }
  }
}
